import type { IconData } from '@stacksjs/iconify-core'

export const darkDislayMode: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 45C12.402 45 3 35.598 3 24S12.402 3 24 3s21 9.402 21 21s-9.402 21-21 21\"/><path d=\"M34.044 14.247c.647.666-.115 1.754-1.043 1.754a8 8 0 1 0 0 16c.928 0 1.69 1.088 1.043 1.754A13.96 13.96 0 0 1 24 38c-7.732 0-14-6.268-14-14s6.268-14 14-14c3.94 0 7.499 1.627 10.043 4.246\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default darkDislayMode
